import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SparkleIconWhite } from '@ui/general';
import { useAnalysisPeriscope } from '@hooks';
export const AiExplainButton = ({ hidden, sonarObjectId }) => {
    const { open } = useAnalysisPeriscope();
    return (React.createElement(FeatureBoundary, { feature: FeatureFlag.AIWorkflowApexClass },
        React.createElement(Button, { className: 'apex-class-ai-explain-button', icon: React.createElement(SparkleIconWhite, null), onClick: () => open(sonarObjectId, SonarObjectType.SalesforceApexClass), style: { display: hidden ? 'none' : 'inline-flex' }, type: 'primary' }, COPY_SPECIFIC.AI_EXPLAIN)));
};
